import request from '../infra/request';
import { buildPatientAuthorizationHeader } from '../utils/patientAccessStorage';

export const fetchSpecialistsTimeSchedule = async ({
  specialistId,
  month,
  timezone,
  newOrReview,
  excludeWorkflowId,
}) => {
  try {
    const { data } = await request.get('/api/specialist/available-time', {
      params: {
        timezone,
        specialistId,
        month,
        appointmentType: newOrReview,
        // Rescheduling: the patient's own appointment must not block its own slot.
        ...(excludeWorkflowId ? { excludeWorkflowId } : {}),
      },
      // patient-api honours the exclusion only for that workflow's verified link.
      ...(excludeWorkflowId
        ? { headers: buildPatientAuthorizationHeader(excludeWorkflowId) }
        : {}),
    });
    return { data };
  } catch (error) {
    return { error };
  }
};
